import { confirmable } from 'react-confirm';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Box } from '@mui/material';
import { InlineGrid } from '@shopify/polaris';
import FormProvider from '../hook_form/form_provider';
import { RHFDigitField } from '../hook_form/rhf_digit_field';
import { requiredField } from 'src/utils/format_data';
import StackedModal from './stacked_modal';
import i18n from 'src/locales/i18n';

i18n.loadNamespaces(['settings_locations']);

function TrackingNumberDialog({ show, proceed }) {
  const { t } = useTranslation(['common', 'placeholder', 'validation', 'settings_locations']);

  const schema = Yup.object().shape({
    fromValue: Yup.string().required(t('validation:range_from_required')),
    toValue: Yup.string().required(t('validation:range_to_required')),
  });

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: { fromValue: '', toValue: '' },
  });

  const onSubmit = methods.handleSubmit((data) => {
    proceed({ confirmed: true, fromValue: data.fromValue, toValue: data.toValue });
  });

  return (
    <StackedModal
      isOpen={show}
      title={t('settings_locations:create_tracking_no')}
      content={
        <FormProvider
          methods={methods}
          onSubmit={onSubmit}
        >
          <Box width={'100%'}>
            <InlineGrid
              columns={2}
              gap="200"
            >
              <RHFDigitField
                name="fromValue"
                displayName={requiredField(t('settings_locations:field.range_from'))}
                placeholder={t('placeholder:range_from')}
              />
              <RHFDigitField
                name="toValue"
                displayName={requiredField(t('settings_locations:field.range_to'))}
                placeholder={t('placeholder:range_to')}
              />
            </InlineGrid>
          </Box>
        </FormProvider>
      }
      primaryAction={{
        content: t('common:button.done'),
        onAction: onSubmit,
        isSubmit: true,
      }}
      onClose={() => {
        proceed({ confirmed: false, fromValue: null, toValue: null });
      }}
    />
  );
}

export default confirmable(TrackingNumberDialog);
